import axiosWithAuthInterceptor from '../util/axiosWithAuthInterceptor';

export async function Clear_customer_info_form(form: any) {
   return  axiosWithAuthInterceptor.post(`${process.env.REACT_APP_LIMOOME_SERVER}/external-sale/clear-customer-info`, form,).then(res => { 
        return res;
    })
}

export async function edit_diet_type_form(form: any) {
    return axiosWithAuthInterceptor.post(`${process.env.REACT_APP_LIMOOME_SERVER}/external-sale/change-type`, form, {}).then(res => {
        return res
    })
}

export async function edit_limooplus_diet_type_form(form: any) {
    return axiosWithAuthInterceptor.post(`${process.env.REACT_APP_LIMOOME_SERVER}/external-sale/transfer-limooplus`, form,).then(res => {
        return res
    })
}
export async function edit_customer_phoneNumber(form: any) {
    return axiosWithAuthInterceptor.post(`${process.env.REACT_APP_LIMOOME_SERVER}/external-sale/change-mobile`, form,).then(res => {
        return res
    })
}
